<mat-form-field appearance="fill">
    <mat-label>Current first Line Address</mat-label>
    <input  matInput class="input"
            type="text"
            [(ngModel)]="autocompleteInput"
            #addresstext
            required>
</mat-form-field>